import * as z from 'zod';

const PUBLIC_ENV_BASE = 'VITE_';

const createEnv = () => {
  const EnvSchema = z.object({
    API_URL: z.string(),
    STAGING_API_URL: z.string().optional(),
  });

  const envVars = Object.entries(import.meta.env).reduce<
    Record<string, string>
  >((acc, curr) => {
    const [key, value] = curr;
    if (key.startsWith(PUBLIC_ENV_BASE)) {
      acc[key.replace(PUBLIC_ENV_BASE, '')] = value;
    }
    return acc;
  }, {});

  const parsedEnv = EnvSchema.safeParse(envVars);

  if (!parsedEnv.success) {
    throw new Error(
      `
      Invalid env provided.
      The following variables are missing or invalid:
      ${Object.entries(parsedEnv.error.flatten().fieldErrors)
        .map(([k, v]) => `- ${k}: ${v}`)
        .join('\n')}
      `,
    );
  }

  return parsedEnv.data;
};

export const env = createEnv();
